import { Button } from "@mui/material";
import React from "react";
import { useFormik } from "formik";
import { useDeleteUserMutation } from "state/api";

const DeleteUser = ({ data }) => {
  const formik = useFormik({
    initialValues: {
      email: data.email,
    },
    onSubmit: (values) => {
      // submit the form using rtk query mutation and close the dialog
      deleteUser({
        email: values.email,
      })
        .unwrap()
        .then((res) => {
          alert("User Deleted successfully");
        })
        .catch((err) => {
          alert("Error in Deleting user");
        });
      // above code can be replaced with a toast notification

      //   reset the form fields
      formik.resetForm();
    },
  });
  const [deleteUser] = useDeleteUserMutation();

  return (
    <div>
      <form onSubmit={formik.handleSubmit}>
        <Button
          variant="contained"
          size="small"
          className="bg-red-600 text-gray-50 hover:bg-red-700"
          type="submit"
        >
          Delete
        </Button>
      </form>
    </div>
  );
};

export default DeleteUser;
